import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, { class: "rounded-lg p-4 text-purple-100 dark:text-purple-700 bg-purple-600 dark:bg-purple-300 w-32 sm:w-40 md:w-48 lg:w-52 xl:w-56 2xl:w-60 hover:bg-purple-900 dark:hover:bg-purple-400" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}